// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const silvally: PokeData = {
  "id": 773,
  "name": "silvally",
  "height": 23,
  "weight": 1005,
  "base_experience": 257,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "razor-wind",
    "tackle",
    "take-down",
    "double-edge",
    "bite",
    "rage",
    "explosion",
    "tri-attack",
    "scary-face",
    "pursuit",
    "crunch",
    "imprison",
    "poison-fang",
    "crush-claw",
    "metal-sound",
    "aerial-ace",
    "heal-block",
    "punishment",
    "air-slash",
    "x-scissor",
    "thunder-fang",
    "ice-fang",
    "fire-fang",
    "iron-head",
    "double-hit",
    "parting-shot",
    "multi-attack"
  ],
  "moves": [
    "tackle",
    "bite",
    "tri-attack",
    "scary-face",
    "pursuit",
    "crunch",
    "poison-fang",
    "metal-sound",
    "aerial-ace",
    "air-slash",
    "thunder-fang",
    "ice-fang",
    "fire-fang"
  ],
  "evolution_chain": {
    "id": 399,
    "item": null,
    "species": [
      {
        "name": "type-null",
        "order": 772,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "silvally",
        "order": 773,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 772,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 133,
    "ability_power": 133
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
